module.exports = __webpack_public_path__ + "img/Watchlist (Active).1b25614e.svg";